module.exports = __webpack_public_path__ + "media/images/front/icon_tag-8c7376bf99d502f780e61430cb55f77f.png";